import PortfolioLayout from './portfolioLayout.js';

export default PortfolioLayout;
